export class FilterValue {
  _id?: string;
  name: string = '';
  position: number = 0;
  active: boolean = false;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/filters/shared/filter-value.model.ts